import React, { FC, ReactNode } from 'react'

import { DistanceUnknownText } from './DistanceUnknownText'
import { SeenRecentlyText } from './SeenRecentlyText'

export const DistanceUnknownSeenRecently: FC<{
  showSeenRecently: boolean
  gender: string
  separator?: ReactNode
}> = ({ showSeenRecently, gender, separator }) => {
  return (
    <>
      <DistanceUnknownText />
      {showSeenRecently && (
        <>
          {separator}
          <SeenRecentlyText gender={gender} />
        </>
      )}
    </>
  )
}
